<template>
  <ActionDropdown :actions="actions" :cssClass="cssClass" />
  <TriggerModal ref="TriggerModal" @created="$emit('created', $event)" />
  <ImportModal ref="ImportModal" @created="$emit('created', $event)" endpoint="triggers/import" :name="i18n('Triggers')"
    :columns="[
      'Application',
      'Profile',
      'TriggerType',
      'Params',
    ]"
  >
  </ImportModal>
</template>
<script>
import TriggerModal from "@/components/trigger/TriggerModal.vue";
import ActionDropdown from "@/components/common/list/ActionDropdown.vue";
import ImportModal from "@/components/common/import/ImportModal.vue";

import api from "@/api.js";

export default {
  components: {
    TriggerModal,
    ActionDropdown,
    ImportModal,
  },
  props: {
    btnClass: {
      type: String,
      default: 'btn btn-sm btn-outline-dark',
    },
    cssClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      formData: {},
    };
  },
  emits: [
    'created'
  ],
  methods: {
    showTriggerModal() {
      this.$refs['TriggerModal'].show();
    },
  },
  
  computed: {
    actions() {
      return [
        {
          label: this.i18n('Add New'),
          fn: () => {
            this.$refs['TriggerModal'].show();
          },
          starred: true,
        },
        {
          label: this.i18n('Export'),
          fn: () => {
            api.getFile('triggers/export', {}, 'triggers.xlsx');
          },
          if: this.can('EXPORT_MANAGE'),
        },
        {
          label: this.i18n('Import'),
          fn: () => {
            this.$refs['ImportModal'].show();
          },
          if: this.can('IMPORT_MANAGE'),
        },
      ];
    },
  },
};
</script>